import { MatPaginatorIntl } from '@angular/material/paginator';

export class PaginatorIntl extends MatPaginatorIntl {
	firstPageLabel = 'Primeira página';

	getRangeLabel = (page: number, pageSize: number, length: number): string => {
		if (length === 0 || pageSize === 0) {
			return `0 ${this.ofLabel} ${length}`;
		}

		const startIndex = page * pageSize;
		const endIndex =
			startIndex < length
				? Math.min(startIndex + pageSize, length)
				: startIndex + pageSize;

		return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length}`;
	};

	itemsPerPageLabel = 'Itens por página';
	lastPageLabel = 'Ultima página';
	nextPageLabel = 'Próxima página';
	ofLabel = 'de';

	previousPageLabel = 'Página anterior';
}
